import '../style/coin-DTh4jbKr.css'
import { defineComponent as L, useCssVars as B, inject as C, computed as i, openBlock as a, createElementBlock as t, normalizeClass as u, unref as s, Fragment as S, createBlock as $, createCommentVNode as d, createElementVNode as p, toDisplayString as _, renderSlot as E, createTextVNode as R } from "vue";
import { configProviderInjectionKey as w } from "./config-provider.js";
import P from "./skeleton.js";
import { SIZE_MAP as V } from "./constant/coin.js";
import { useComponentClassList as I } from "./hooks/useComponentClassList.js";
import { useGlobalDark as M } from "./hooks/useGlobalDark.js";
import { useImageLazy as b } from "./hooks/useImageLazy.js";
const j = ["data-src", "alt"], A = ["src", "alt"], O = { class: "e-coin__name" }, T = {
  key: 0,
  class: "e-coin__desc"
}, U = "e-coin", Q = /* @__PURE__ */ L({
  name: "e-coin",
  __name: "coin",
  props: {
    coin: { default: "" },
    coinDesc: {},
    descLayout: { default: "horizontal" },
    name: {},
    theme: {},
    showName: { type: Boolean, default: !0 },
    size: { default: "md" },
    iconSize: {},
    delay: { default: 0 },
    lazy: { type: Boolean, default: !1 }
  },
  setup(y) {
    B((o) => ({
      "44dde607": h.value
    }));
    const e = y, k = C(w, {
      coinBaseUrl: "https://static2.crypto.com/exchange/token-icons"
    }), v = M(), g = I(U, {
      size: e.size
    }), z = i(() => e.theme ?? (v.value ? "dark" : "light")), r = i(() => `${k.coinBaseUrl}/${z.value}/${e.coin}.png`), h = i(() => (e.iconSize ?? V[e.size]) + "px"), l = i(() => e.name || e.coin), { loaded: N, imgRef: f, rootRef: D, handleLoad: n } = b({
      dataSrc: r,
      delay: e.delay,
      disabled: !e.lazy
    });
    return (o, c) => (a(), t("div", {
      ref_key: "rootRef",
      ref: D,
      class: u(s(g))
    }, [
      o.lazy ? (a(), t(S, { key: 0 }, [
        s(N) ? d("", !0) : (a(), $(s(P), {
          key: 0,
          class: "e-coin__skeleton"
        })),
        p("img", {
          ref_key: "imgRef",
          ref: f,
          class: "e-coin__icon",
          "data-src": r.value,
          alt: l.value,
          onLoad: c[0] || (c[0] = //@ts-ignore
          (...m) => s(n) && s(n)(...m))
        }, null, 40, j)
      ], 64)) : (a(), t("img", {
        key: 1,
        ref_key: "imgRef",
        ref: f,
        class: "e-coin__icon",
        src: r.value,
        alt: l.value,
        onLoad: c[1] || (c[1] = //@ts-ignore
        (...m) => s(n) && s(n)(...m))
      }, null, 40, A)),
      o.showName ? (a(), t("div", {
        key: 2,
        class: u(["e-coin__wrapper", { "e-coin__wrapper--vertical": o.descLayout === "vertical" }])
      }, [
        p("span", O, _(l.value), 1),
        o.coinDesc || o.$slots.coinDesc ? (a(), t("span", T, [
          E(o.$slots, "coinDesc", {}, () => [
            R(_(o.coinDesc), 1)
          ])
        ])) : d("", !0)
      ], 2)) : d("", !0)
    ], 2));
  }
});
export {
  Q as default
};
//# sourceMappingURL=coin.js.map
